import axios from 'axios';

const instance = axios.create({
    baseURL: `/${process.env.MIX_APP_BASE_PATH}/api/`.replace('//', '/'),
});

instance.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
};

export default instance;
